import cn from 'classnames';
import type { ReactNode } from 'react';
import { HugContentFooter } from './hug-content-footer';
import styles from './modal-hug-content.module.css';

export type ModalHugContentProperties = {
  children?: ReactNode;
  className?: string;
};

const ModalHugContent = ({ children, className }: ModalHugContentProperties) => (
  <div className={cn(className, styles['modal-hug-content'])}>{children}</div>
);

ModalHugContent.Footer = HugContentFooter;

export default ModalHugContent;
